import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLightModeBright = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "light-mode-bright" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M20.25,9H3.75a3,3,0,0,0,0,6h16.5a3,3,0,0,0,0-6Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 18,
			y1: 18,
			x2: 19.5,
			y2: 20.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 5.25,
			y1: 18,
			x2: 3.75,
			y2: 20.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 11.25,
			y1: 22.5,
			x2: 11.25,
			y2: 18.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 18,
			y1: 6,
			x2: 19.5,
			y2: 3.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 5.25,
			y1: 6,
			x2: 3.75,
			y2: 3.75
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 11.25,
			y1: 1.5,
			x2: 11.25,
			y2: 5.25
		})
	]
});
export default SvgLightModeBright;
